export default __webpack_public_path__ + "static/media/paper_type_2.52f41791.png";